import {
  GET_OPERATIONS_MACHINE_MAP_FAILURE,
  GET_OPERATIONS_MACHINE_MAP_REQUEST,
  GET_OPERATIONS_MACHINE_MAP_SUCCESS,
} from "./operationsMachineMapTypes";

const initialState = {
  loading: false,
  labels: [],
  error: "",
};

const getOperationMachineMapReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OPERATIONS_MACHINE_MAP_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATIONS_MACHINE_MAP_SUCCESS:
      return {
        loading: false,
        labels: action.payload,
        error: "",
      };
    case GET_OPERATIONS_MACHINE_MAP_FAILURE:
      return {
        loading: false,
        labels: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   labels: [],
//   error: "",
// };

// const getLabelsWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_LABELS_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_LABELS_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         labels: action.payload,
//         error: "",
//       };
//     case GET_LABELS_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         labels: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

// const initialStateForPrinters = {
//   loading: false,
//   printers: [],
//   error: "",
// };

// const getPrintersForLabelCreationReducer = (
//   state = initialStateForPrinters,
//   action
// ) => {
//   switch (action.type) {
//     case GET_PRINTERS_FOR_LABEL_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_PRINTERS_FOR_LABEL_SUCCESS:
//       return {
//         loading: false,
//         printers: action.payload,
//         error: "",
//       };
//     case GET_PRINTERS_FOR_LABEL_FAILURE:
//       return {
//         loading: false,
//         printers: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };
export {
  getOperationMachineMapReducer,
  //   getLabelsWithPaginationReducer,
  //   getPrintersForLabelCreationReducer,
};
